import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'dashboards-directory-secure',
	path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)',
};
